// Уточнюючий розрахунок податкових зобов'язань з ПДВ у зв'язку з виправленням самостійно виявлених помилок (J0217026,
// наказ Мінфіну № 21 у ред. № 400; бланк — xsd_all/254863/J0217026.pdf). Для кожного рядка декларації три графи:
// 4 — показник, який уточнюється (з поданої декларації або попереднього уточнюючого розрахунку за той самий період),
// 5 — уточнений показник, 6 — різниця (5 − 4). Рядок 18.1 — штраф, нарахований самостійно (п. 50.1 ПКУ: 3 % суми недоплати,
// якщо уточнюючий розрахунок подано й податок зі штрафом сплачено до подання). Підсумкові рядки (9, 16, 17, 18–21) рахуємо
// самі за тими самими правилами, що й декларацію (lib/vat/declaration.js). Бюджетне відшкодування (рядки 20.1, 20.2) не
// підтримується — як і в майстрі декларації.

const esc = (s) => String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
const ddmmyyyy = (d) => { const t = d instanceof Date ? d : new Date(d); return `${String(t.getDate()).padStart(2, "0")}${String(t.getMonth() + 1).padStart(2, "0")}${t.getFullYear()}`; };
const r0 = (x) => Math.round(Number(x) || 0);

export const UR_CDOC = "J0217026";
export const UR_NAME = "Уточнюючий розрахунок податкових зобов'язань з податку на додану вартість у зв'язку з виправленням самостійно виявлених помилок";
export const UR_FINE_PCT = 3; // п. 50.1 ПКУ — самостійне виправлення з попередньою сплатою

// Рядки бланка в порядку схеми: [код рядка, графа декларації (А — обсяг, Б — ПДВ), назва, підсумковий (рахуємо самі)]
export const UR_LINES = [
  ["I", null, "I. Податкові зобов'язання"],
  ["1.1", "R11G", "Операції за основною ставкою (крім ввезення)"],
  ["1.2", "R12G", "Операції за ставкою 7 %"],
  ["1.3", "R13G", "Операції за ставкою 14 %"],
  ["2.1", "R21G", "Вивезення товарів — нульова ставка", "A"],
  ["2.2", "R22G", "Вивезення товарів — звільнені", "A"],
  ["2.3.1", "R231G", "Експорт окремих товарів — нульова ставка", "A"],
  ["2.3.2", "R232G", "Експорт окремих товарів — основна ставка"],
  ["2.3.3", "R233G", "Експорт окремих товарів — 14 %"],
  ["3", "R30G", "Інші операції за нульовою ставкою", "A"],
  ["4.1", "R41G", "Нараховано за п. 198.5, 199.1 — основна ставка"],
  ["4.1.1", "R411G", "з них коригування"],
  ["4.2", "R42G", "Нараховано за п. 198.5, 199.1 — 7 %"],
  ["4.2.1", "R421G", "з них коригування"],
  ["4.3", "R43G", "Нараховано за п. 198.5, 199.1 — 14 %"],
  ["4.3.1", "R431G", "з них коригування"],
  ["5", "R50G", "Не є об'єктом, за межами митної території, звільнені", "A"],
  ["5.1", "R51G", "у тому числі звільнені", "A"],
  ["5.1.1", "R511G", "з них коригування обсягів", "A"],
  ["6.1", "R61G", "Послуги нерезидента — основна ставка"],
  ["6.2", "R62G", "Послуги нерезидента — 7 %"],
  ["7.1", "R71G", "Коригування обсягів постачання та зобов'язань"],
  ["7.1.1", "R711G", "у тому числі за нульовою ставкою", "A"],
  ["7.2.1", "R721G", "Коригування експорту окремих товарів — нульова ставка", "A"],
  ["7.2.2", "R722G", "Коригування експорту окремих товарів — основна ставка"],
  ["7.2.3", "R723G", "Коригування експорту окремих товарів — 14 %"],
  ["8", "R80G", "Нецільове використання товарів, ввезених зі звільненням"],
  ["9", "R90G", "Усього за розділом I", "B", true],
  ["II", null, "II. Податковий кредит"],
  ["10.1", "R101G", "Придбання на митній території — основна ставка"],
  ["10.2", "R102G", "Придбання — 7 %"],
  ["10.3", "R103G", "Придбання — 14 %"],
  ["10.4", "R104G", "Придбання з нульовою ставкою / без ПДВ", "A"],
  ["11.1", "R111G", "Ввезені товари — основна ставка"],
  ["11.2", "R112G", "Ввезені товари — 7 %"],
  ["11.3", "R113G", "Ввезені товари — 14 %"],
  ["11.4", "R114G", "Ввезені товари без ПДВ", "A"],
  ["12", "R120G", "Погашені податкові векселі"],
  ["13.1", "R131G", "Послуги нерезидента — основна ставка"],
  ["13.2", "R132G", "Послуги нерезидента — 7 %"],
  ["14", "R140G", "Коригування податкового кредиту"],
  ["15.1", "R151G", "Коригування за п. 192.1.1 (повернення без РК в ЄРПН)"],
  ["15.2", "R152G", "Перерахунок частки необоротних активів до 01.07.2015"],
  ["16", "R160G", "Від'ємне значення, що включається до кредиту", "B", true],
  ["16.1", "R161G", "значення рядка 21 попереднього періоду", "B"],
  ["16.2", "R162G", "змінено за уточнюючими розрахунками", "B"],
  ["16.3", "R163G", "змінено за результатами перевірки", "B"],
  ["17", "R170G", "Усього за розділом II", "B", true],
  ["III", null, "III. Розрахунки за звітний період"],
  ["18", "R180G", "До сплати (рядок 9 − рядок 17)", "B", true],
  ["19", "R190G", "Від'ємне значення (рядок 17 − рядок 9)", "B", true],
  ["19.1", "R191G", "перевищення над сумою за п. 200¹.3", "B", true],
  ["20", "R200G", "Від'ємне значення в межах суми за п. 200¹.3", "B", true],
  ["20.1", "R201G", "у зменшення податкового боргу", "B", true],
  ["20.2", "R202G", "до бюджетного відшкодування", "B", true],
  ["20.2.1", "R2021G", "на рахунок у банку", "B", true],
  ["20.2.2", "R2022G", "у рахунок інших платежів", "B", true],
  ["20.3", "R203G", "до кредиту наступного періоду", "B", true],
  ["21", "R210G", "Від'ємне значення до кредиту наступного періоду (рядок 16.1 наступної декларації)", "B", true],
];
// Колонки рядка: «A» — лише обсяг, «B» — лише ПДВ, без позначки — обидві
export const urKeys = ([, base, , cols]) => (!base ? [] : cols === "A" ? [`${base}A`] : cols === "B" ? [`${base}B`] : [`${base}A`, `${base}B`]);
const ALL = UR_LINES.flatMap(urKeys);
const INPUT = new Set(UR_LINES.filter((l) => !l[4]).flatMap(urKeys));
export const isUrInput = (k) => INPUT.has(k);

// Підсумки за правилами декларації. v — { R11GB: …, … } (усі рядки, числа); regSum — сума за п. 200¹.3 на момент подання
const SEC1 = ["R11GB", "R12GB", "R13GB", "R232GB", "R233GB", "R41GB", "R42GB", "R43GB", "R61GB", "R62GB", "R71GB", "R722GB", "R723GB", "R80GB"];
const SEC2 = ["R101GB", "R102GB", "R103GB", "R111GB", "R112GB", "R113GB", "R120GB", "R131GB", "R132GB", "R140GB", "R151GB", "R152GB", "R160GB"];
export function urTotals(v, regSum = null) {
  const x = { ...v }, g = (k) => Number(x[k]) || 0;
  x.R160GB = g("R161GB") + g("R162GB") + g("R163GB");
  x.R90GB = SEC1.reduce((a, k) => a + g(k), 0);
  x.R170GB = SEC2.reduce((a, k) => a + g(k), 0);
  const diff = x.R90GB - x.R170GB;
  x.R180GB = diff > 0 ? diff : 0;
  x.R190GB = diff < 0 ? -diff : 0;
  // Від'ємне значення: у межах суми за п. 200¹.3 — рядок 20 → 20.3 (відшкодування не підтримується), решта — 19.1; рядок 21 = 19.1 + 20.3
  const s = regSum == null ? x.R190GB : Math.max(0, Number(regSum) || 0);
  x.R200GB = Math.min(x.R190GB, s);
  x.R191GB = x.R190GB - x.R200GB;
  x.R201GB = 0; x.R202GB = 0; x.R2021GB = 0; x.R2022GB = 0;
  x.R203GB = x.R200GB;
  x.R210GB = x.R191GB + x.R203GB;
  return x;
}

// Розрахунок. base — рядки декларації, що уточнюється (графа 4); edits — уточнені значення (графа 5) лише рядків, які
// людина змінила; regSum — сума за п. 200¹.3 на момент подання (для рядків 19.1/20); finePct — 3 або 0 (пільга)
// → { ok, errors, warnings, lines: [{ line, label, keys: [{ key, before, after, diff, input }] }], rows (для XML), fine, pay }
export function computeUr({ base, edits = {}, regSum = null, finePct = UR_FINE_PCT }) {
  const errors = [], warnings = [];
  const b = Object.fromEntries(ALL.map((k) => [k, r0(base?.[k])]));
  // Підсумки декларації, що уточнюється, мають сходитися з нашими правилами — інакше графа 5 вийде хибною
  const check = urTotals(b, b.R190GB > 0 ? b.R200GB : null);
  const off = ["R90GB", "R170GB", "R180GB", "R190GB"].filter((k) => Math.abs(check[k] - b[k]) > 1);
  if (off.length) errors.push(`Підсумки поданої декларації не сходяться з правилами розрахунку (${off.map((k) => k.replace(/^R(\d+)\d?G.*/, "рядок $1")).join(", ")}) — уточнюючий розрахунок для неї складіть у кабінеті ДПС.`);
  if (b.R201GB || b.R202GB) errors.push("У декларації заявлено бюджетне відшкодування (рядок 20.1 чи 20.2) — такий уточнюючий розрахунок eCabinet поки не складає.");
  const after = { ...b };
  for (const [k, val] of Object.entries(edits || {})) if (INPUT.has(k) && val !== "" && val != null && Number.isFinite(Number(val))) after[k] = r0(val);
  const t = urTotals(after, after.R190GB > 0 || b.R190GB > 0 ? (regSum ?? b.R200GB) : null);
  const rows = {};
  const lines = UR_LINES.map((l) => ({ line: l[0], label: l[2], total: Boolean(l[4]), section: !l[1],
    keys: urKeys(l).map((k) => { const before = b[k], aft = t[k]; rows[k] = { before, after: aft, diff: aft - before }; return { key: k, before, after: aft, diff: aft - before, input: INPUT.has(k) }; }) }));
  const changed = ALL.some((k) => rows[k].diff !== 0);
  if (!changed) errors.push("Уточнених показників немає — змініть хоча б один рядок у графі 5.");
  const d18 = rows.R180GB.diff, fine = d18 > 0 ? r0((d18 * finePct) / 100) : 0;
  if (rows.R210GB.diff) warnings.push(`Змінюється від'ємне значення, що переходить у наступний період (рядок 21, ${rows.R210GB.diff > 0 ? "+" : ""}${rows.R210GB.diff} грн): у декларації за наступний звітний період відобразіть цю різницю в рядку 16.2.`);
  if (d18 > 0) warnings.push(`До подання сплатіть ${d18 + fine} грн: недоплата ${d18} грн${fine ? ` і штраф ${fine} грн (${finePct} %)` : ""} — інакше штраф буде більший (п. 50.1 ПКУ).`);
  if (d18 < 0) warnings.push(`Податкове зобов'язання зменшується на ${-d18} грн — переплату буде зараховано на особовому рахунку.`);
  return { ok: !errors.length, errors, warnings, lines, rows, fine, pay: d18 > 0 ? d18 + fine : 0, regSum: t.R190GB > 0 ? (regSum ?? b.R200GB) : null };
}

// XML J0217026. period — звітний період, у якому подається (YYYY-MM), corrects — період, що уточнюється (YYYY-MM);
// hvpp — показники цього періоду вже уточнювались раніше; org — реквізити з останньої декларації (orgFromXml)
export function buildUrXml({ org, ur, period, corrects, hvpp = false, docCnt = 1, fillDate = new Date() }) {
  const [y, m] = period.split("-").map(Number), [py, pm] = corrects.split("-").map(Number);
  const L = [`<?xml version="1.0" encoding="windows-1251"?>`,
    `<DECLAR xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="${UR_CDOC}.xsd">`, `    <DECLARHEAD>`];
  const put = (t, v) => L.push(`        <${t}>${esc(v)}</${t}>`);
  put("TIN", org.tin); put("C_DOC", "J02"); put("C_DOC_SUB", "170"); put("C_DOC_VER", "26"); put("C_DOC_TYPE", 0); put("C_DOC_CNT", docCnt);
  put("C_REG", org.reg); put("C_RAJ", org.raj); put("PERIOD_MONTH", m); put("PERIOD_TYPE", 1); put("PERIOD_YEAR", y);
  put("C_STI_ORIG", org.sti); put("C_DOC_STAN", 1);
  L.push(`        <LINKED_DOCS xsi:nil="true"/>`);
  put("D_FILL", ddmmyyyy(fillDate)); put("SOFTWARE", "eCabinet 1.0");
  L.push(`    </DECLARHEAD>`, `    <DECLARBODY>`);
  put("HZY", y); put("HZM", m); put("HZYP", py); put("HZMP", pm);
  if (hvpp) put("HVPP", 1);
  put("HNAME", org.name); put("HTIN", org.tin); put("HNPDV", org.ipn);
  for (const [t, k] of [["HLOC", "loc"], ["HZIP", "zip"], ["HTEL", "tel"], ["HEMAIL", "email"]]) if (org[k]) put(t, org[k]);
  put("HSTI", org.stiName);
  // Рядки — у порядку схеми: графа 4, 5, 6; рядок без жодного значення не виводимо. 18.1 (штраф) — після 18, 19.1 гр. 3 — перед 19.1
  const nz = (k) => ur.rows[k] && (ur.rows[k].before || ur.rows[k].after || ur.rows[k].diff);
  for (const k of ALL) {
    if (k === "R190GB" && ur.fine) put("R181GB6", ur.fine);
    if (k === "R191GB" && ur.regSum != null) put("R191G3", r0(ur.regSum));
    if (!nz(k)) continue;
    put(`${k}4`, ur.rows[k].before); put(k, ur.rows[k].after); put(`${k}6`, ur.rows[k].diff);
  }
  put("HFILL", ddmmyyyy(fillDate)); put("HBOS", org.bos); put("HKBOS", org.kbos);
  L.push(`    </DECLARBODY>`, `</DECLAR>`);
  return L.join("\n");
}

// Бланк уточнюючого розрахунку з XML (для перегляду перед підписом — з байтів, які дає кабінет ДПС). css — lib/vat/form.css
const n0 = (v) => (v == null || v === "" ? "" : Number(v).toLocaleString("uk-UA"));
const hesc = (s) => esc(s).replace(/"/g, "&quot;");
export function urBlankHtml(xml, { cssHref = "" } = {}) {
  const t = (k) => { const m = String(xml).match(new RegExp(`<${k}>([^<]*)</${k}>`)); return m ? m[1] : ""; };
  const has = (k) => new RegExp(`<${k}>`).test(xml);
  const MONTHS = ["січень", "лютий", "березень", "квітень", "травень", "червень", "липень", "серпень", "вересень", "жовтень", "листопад", "грудень"];
  const per = (y, m) => (y && m ? `${MONTHS[Number(m) - 1]} ${y}` : "");
  const rows = UR_LINES.map((l) => {
    if (!l[1]) return `<tr class="sec"><td colspan="6"><b>${esc(l[2])}</b></td></tr>`;
    return urKeys(l).filter((k) => has(k) || has(`${k}4`)).map((k, i) => `<tr${l[4] ? ' class="tot"' : ""}><td class="c">${i ? "" : esc(l[0])}</td><td>${i ? "" : esc(l[2])}</td><td class="c">${k.endsWith("A") ? "А" : "Б"}</td>
      <td class="r v">${n0(t(`${k}4`))}</td><td class="r v">${n0(t(k))}</td><td class="r v">${n0(t(`${k}6`))}</td></tr>`).join("")
      + (l[0] === "18" && has("R181GB6") ? `<tr><td class="c">18.1</td><td>Штраф, нарахований самостійно (при позитивному значенні графи 6 рядка 18)</td><td></td><td></td><td></td><td class="r v">${n0(t("R181GB6"))}</td></tr>` : "")
      + (l[0] === "19.1" && has("R191G3") ? `<tr><td></td><td class="small">сума за п. 200¹.3 на момент подання: <b>${n0(t("R191G3"))}</b></td><td></td><td></td><td></td><td></td></tr>` : "");
  }).join("");
  const body = `<h2>Уточнюючий розрахунок податкових зобов'язань з податку на додану вартість у зв'язку з виправленням самостійно виявлених помилок</h2>
  <table class="bx"><tr><td class="cd">02</td><td>Звітний (податковий) період</td><td><b>${esc(per(t("HZY"), t("HZM")))}</b></td></tr>
  <tr><td class="cd">03</td><td>Звітний (податковий) період, що уточнюється</td><td><b>${esc(per(t("HZYP"), t("HZMP")))}</b></td></tr>
  <tr><td class="cd">031</td><td>Показники цього періоду вже уточнювалися раніше</td><td>${has("HVPP") ? "Х" : ""}</td></tr>
  <tr><td class="cd">04</td><td>Платник</td><td><b>${esc(t("HNAME"))}</b> · код ${esc(t("HTIN"))} · ІПН ${esc(t("HNPDV"))}</td></tr>
  <tr><td class="cd">06</td><td>Податкова адреса</td><td>${esc(t("HLOC"))}</td></tr></table>
  <p class="small">Розрахунок подається до: <b>${esc(t("HSTI"))}</b> <span class="r">(грн)</span></p>
  <table class="bx rows"><thead><tr><th class="cd">Код рядка</th><th>Рядки декларації</th><th class="cd">Колонка</th><th class="num">4 — показник, який уточнюється</th><th class="num">5 — уточнений показник</th><th class="num">6 — різниця</th></tr></thead>
  <tbody>${rows}</tbody></table>
  <table class="sign"><tr><td>Дата подання: <b>${esc(t("HFILL"))}</b></td><td>Керівник: <b>${esc(t("HBOS"))}</b></td><td>РНОКПП: <b>${esc(t("HKBOS"))}</b></td></tr></table>`;
  return `<!doctype html><html lang="uk"><head><meta charset="utf-8"><title>Уточнюючий розрахунок з ПДВ</title>${cssHref ? `<link rel="stylesheet" href="${hesc(cssHref)}">` : ""}</head><body><div class="page">${body}</div></body></html>`;
}
